import React from 'react';
import { useLanguage } from '../../../../hooks/useLanguage';
import { appData as portfolioData } from '../../../../data/portfolioData';
import { appData } from '../../../../data/appData';
import './About.css';

const About = () => {
  const { getText, currentLanguage } = useLanguage();

  // Obtener los datos de about del appData usando el idioma actual
  const aboutData = appData.languages[currentLanguage]?.about;

  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">{getText('portfolio.about.title')}</span>
          <h2 className="section-title">{getText('portfolio.hero.greeting')} {portfolioData.personal.name}</h2>
          <p className="section-description">
            {getText('portfolio.about.description')}
          </p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <div className="intro">
              <h3>{getText('portfolio.hero.greeting')} {portfolioData.personal.name}</h3>
              <p className="role">{getText('portfolio.hero.profession')}</p>
              <p className="description">
                {getText('portfolio.hero.description')}
              </p>
            </div>

            <div className="journey">
              <h4>{getText('portfolio.experience.title')}</h4>
              <p>
                {getText('portfolio.experience.subtitle')}
              </p>
              
              <p>
                {getText('portfolio.about.description')}
              </p>
            </div>

            <div className="values">
              <h4>{aboutData?.features?.title || getText('about.features.title')}</h4>
              <div className="values-grid">
                {aboutData?.features?.items?.map((item, index) => (
                  <div key={index} className="value-item">
                    <span className="value-icon">{['🎯', '🚀', '🤝', '💡'][index]}</span>
                    <div>
                      <h5>{item.title}</h5>
                      <p>{item.description}</p>
                    </div>
                  </div>
                )) || null}
              </div>
            </div>
          </div>

          <div className="about-stats">
            <h4>{getText('portfolio.about.stats.experience')}</h4>
            <div className="stats-grid">
              <div className="stat-item">
                <span className="stat-number">50+</span>
                <span className="stat-label">{getText('portfolio.about.stats.projects')}</span>
              </div>
              
              <div className="stat-item">
                <span className="stat-number">5+</span>
                <span className="stat-label">{getText('portfolio.about.stats.experience')}</span>
              </div>
              
              <div className="stat-item">
                <span className="stat-number">20+</span>
                <span className="stat-label">{getText('portfolio.about.stats.technologies')}</span>
              </div>
              
              <div className="stat-item">
                <span className="stat-number">100%</span>
                <span className="stat-label">{getText('portfolio.about.stats.clients')}</span>
              </div>
            </div>

            <div className="personal-note">
              <div className="note-icon">💭</div>
              <div className="note-content">
                <h5>{aboutData?.methodology?.title || getText('about.methodology.title')}</h5>
                <p>
                  {aboutData?.methodology?.description || getText('about.methodology.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
